var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParkingSign = function SvgParkingSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#parkingSign_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M12 23.625c6.42 0 11.625-5.205 11.625-11.625S18.42.375 12 .375.375 5.58.375 12 5.58 23.625 12 23.625"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M12 22.125c5.592 0 10.125-4.533 10.125-10.125S17.592 1.875 12 1.875 1.875 6.408 1.875 12 6.408 22.125 12 22.125"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.25 6v12.75h2.25V13.5h3.375a3.375 3.375 0 0 0 3.375-3.375v-1.5a3.375 3.375 0 0 0-3.375-3.375H9a.75.75 0 0 0-.75.75m5.625 5.25H10.5V7.5h3.375A1.125 1.125 0 0 1 15 8.625v1.5a1.125 1.125 0 0 1-1.125 1.125"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "parkingSign_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgParkingSign;